<template>
    <v-card
        :class="
            $vuetify.display.mobile
                ? 'default_card_mobile elevation-0 ma-0'
                : 'default_card dashboard_card elevation-0'
        "
    >
        <v-card-title primary-title>
            <v-row no-gutters style="flex-wrap: nowrap">
                <v-col
                    cols="3"
                    class="ml-0 mt-0 mb-auto pt-0 pb-auto d-flex flex-grow-0 flex-shrink-1"
                >
                    <!-- <div class="ml-0 mt-0 mb-auto pt-0 pb-auto d-flex"> -->
                    <v-btn-back @click="$emit('onClosingVue')" v-if="activeBack"> </v-btn-back>
                    <span style="white-space: nowrap">{{ title }}</span>
                    <!-- </div> -->
                </v-col>
                <!-- <v-spacer v-if="!$vuetify.display.mobile"></v-spacer> -->
                <v-col cols="4" v-if="showTagSelect">
                    <v-select-filled
                        v-model="_selectedTags"
                        :items="data.tags"
                        item-value="id"
                        v-if="isAllowedTo"
                        multiple
                        class="mt-0 mb-0 pt-0 pb-0 mr-4"
                        label="Etiquettes"
                        data-cy="BarChartCard-selectedTags"
                        density="compact"
                        :item-title="(item) => item.name"
                    >
                        <template v-slot:selection="{ item }">
                            <v-chip label size="small">
                                <span>{{ item.name }}</span>
                            </v-chip>
                        </template>
                    </v-select-filled>
                </v-col>
                <v-col
                    :cols="showTagSelect ? 5 : 9"
                    class="d-flex flex-grow-1 flex-shrink-0 justify-end"
                >
                    <v-switch
                        v-model="_yearNMinus1"
                        class="ml-4 mt-1 mb-0 pt-0 pb-0"
                        label="N-1"
                        v-if="showYearNMinus1"
                        v-show="!detail"
                        data-cy="BarChartCard-yearNMinus1"
                    />
                    <v-switch
                        v-model="cumulative"
                        class="ml-4 mt-1 mb-0 pt-0 pb-0"
                        label="Cumulé"
                        v-if="showCumulative"
                        data-cy="BarChartCard-cumulative"
                    />
                    <!-- <v-switch inset dense v-model="_detail" class="ml-4 mt-1 mb-0 pt-0 pb-0" label="Détaillé" color="primary" v-if="showDetail" data-cy="BarChartCard-detail"></v-switch> -->
                    <!-- <v-btn class="mb-3 ml-4" icon @click="$emit('onClosingVue')"><v-icon>$fa-search-minus</v-icon></v-btn> -->
                </v-col>
            </v-row>
        </v-card-title>
        <v-card-text style="text-align: center" class="pa-0">
            <template v-if="loading">
                <v-progress-circular
                    :size="70"
                    :width="7"
                    color="primary"
                    indeterminate
                    style="margin: 24px"
                />
            </template>
            <template v-else-if="chartData">
                <bar-chart
                    v-if="chartData"
                    :data="chartData"
                    :options="options"
                    :height="$vuetify.display.mobile ? 200 : 350"
                />
            </template>
        </v-card-text>
    </v-card>
</template>

<script lang="ts">
import { Bar as BarChart } from "vue-chartjs";
import { TooltipItem } from "chart.js";

import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";

import { chartColors } from "../../../../backend/src/common/chart/graphServices";

import { Offer_type } from "@/types/offer.types";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { checkAccessRights } from "@/services/accessRightServices";

@Component({
    components: {
        BarChart,
    },
    emits: ["onSelectedTagsChanged", "onYearNMinus1Changed", "onDetailChanged"],
})
export class BarChartCard extends Vue {
    @Prop({ default: "" }) title: string;
    @Prop({ default: false }) stacked: boolean;
    @Prop({ default: false }) legend: boolean;
    @Prop({ default: false }) loading: boolean;
    @Prop({ default: true }) showCumulative: boolean;
    @Prop({ default: false }) yearNMinus1: boolean;
    @Prop({ default: false }) showYearNMinus1: boolean;
    @Prop({ default: false }) showDetail: boolean;
    @Prop({ default: false }) detail: boolean;
    @Prop({ default: null }) data: any;
    @Prop({ default: true }) md6: boolean;
    @Prop({ default: true }) activeBack: boolean;
    @Prop({ default: null }) selectedTags;
    @Prop({ default: 1 }) selectedPeriod: number;

    cumulative: boolean = false;

    currentPalette = "cool";

    get offerType() {
        return this.$store.state.offerType;
    }

    get isAllowedTo() {
        // switch (this.offerType) {
        // case Offer_type.ACCOUNTING_ESSENTIAL:
        // case Offer_type.ACCOUNTING_PREMIUM:
        // case Offer_type.BUSINESS_ESSENTIAL:
        // case Offer_type.BUSINESS_PREMIUM:
        // case Offer_type.TRAINING:
        // return true;
        // default:
        // return false;
        // }
        return checkAccessRights(
            this.$store.state.user,
            "business",
            "dashboard",
            true,
            "isAllowedToDashboard",
        );
    }

    get _selectedTags() {
        return this.selectedTags;
    }

    set _selectedTags(value) {
        this.$emit("onSelectedTagsChanged", value);
    }

    get _yearNMinus1() {
        return this.yearNMinus1;
    }

    set _yearNMinus1(value) {
        this.$emit("onYearNMinus1Changed", value);
    }

    get _detail() {
        return this.detail;
    }

    set _detail(value) {
        this.$emit("onDetailChanged", value);
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    get chartData() {
        // debugger
        if (this.data) {
            // const limitDates = this.selectPeriodFromDatasets;
            let datasets = [];
            let labels = JSON.parse(JSON.stringify(this.data.labels));
            if (this.data.dataset) {
                let data = JSON.parse(JSON.stringify(this.data.dataset));
                if (this.cumulative) {
                    for (let i = 1; i < data.length; i++) {
                        data[i] += data[i - 1];
                    }
                }
                // if (true) { // remplacer par une vraie condition qui indique si on est bien dans le dashboard accounting ou non
                //     data = data.slice(limitDates.start,limitDates.end) // remplacer 0 et 12 par les bons indices à calculer à partir des nouvelles props
                //     labels = labels.slice(limitDates.start,limitDates.end);
                // }
                datasets.push({ data: data });
            } else if (this.data.datasets) {
                datasets = JSON.parse(JSON.stringify(this.data.datasets));
                if (this.cumulative) {
                    for (let j = 0; j < datasets.length; j++) {
                        const data = datasets[j].data;
                        for (let i = 1; i < data.length; i++) {
                            data[i] += data[i - 1];
                        }
                    }
                }
                // if (true) {
                //     for (let dataset of datasets) {
                //         dataset.data = dataset.data.slice(limitDates.start,limitDates.end) // remplacer 0 et 12 par les bons indices à calculer à partir des nouvelles props
                //     }
                //     labels = labels.slice(limitDates.start,limitDates.end);
                // }
            }

            chartColors("bar", datasets, this.currentPalette);
            const chartData = {
                labels: labels,
                datasets: datasets,
            };
            console.log("chartdata: ", chartData);
            return chartData;
        }
        return null;
    }

    get options() {
        if (!this.stacked) {
            // const options = ref<ChartOptions<'bar'>>({
            return {
                plugins: {
                    legend: {
                        display: this.legend,
                        position: "bottom",
                    },
                },
                responsive: true,
                maintainAspectRatio: false,
            };
            // })
            // return options
        }
        // const options = ref<ChartOptions<'bar'>>({
        const self = this;
        return {
            responsive: true,
            plugins: {
                legend: {
                    display: this.legend,
                    position: "bottom",
                },
                tooltip: {
                    mode: "index",
                    position: "average",
                    callbacks: {
                        label: function (tooltipItem: TooltipItem<"bar">): string | string[] {
                            let label = tooltipItem.dataset
                                ? self._detail
                                    ? tooltipItem.dataset.label
                                    : self
                                          .$t("dashboard.amountType." + tooltipItem.dataset.label)
                                          .toString()
                                : "";
                            if (label) {
                                label += " : ";
                            }
                            label += tooltipItem.dataset
                                ? newCommonFormatCurrency(
                                      tooltipItem.dataset.data[tooltipItem.dataIndex],
                                      undefined,
                                  )
                                : tooltipItem.formattedValue;
                            return label;
                        },
                    },
                },
            },
            scales: {
                y: {
                    stacked: true,
                    // min:0,
                    beginAtZero: true,
                    // stepSize: 1
                },
                x: {
                    stacked: true,
                    // min:0,
                    beginAtZero: true,
                },
            },
            maintainAspectRatio: false,
        };
        // })
        // return options
    }

    get showTagSelect() {
        return (
            this.selectedTags &&
            this.data &&
            this.data.tags &&
            this.data.tags.length &&
            !this.$vuetify.display.mobile
        );
    }
}

export default toNative(BarChartCard);
</script>
